import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { Dispatch, SetStateAction, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import Button from "../../../components/Button";

const ClaimsView = ({
  user,
  claims,
  getSessionName,
  setClaims,
  update,
  setUpdateClaims,
  grandprix,
}: {
  user: string;
  claims: ClaimGP[];
  getSessionName: (session: number) => string;
  setClaims: Dispatch<SetStateAction<ClaimGP[]>>;
  update: (claim_: ClaimGP) => void;
  setUpdateClaims: Dispatch<SetStateAction<boolean>>;
  grandprix: string;
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setClaimToDelete(-1);
    setShow(false);
  };
  const handleShow = (claim_id: number) => {
    setClaimToDelete(claim_id);
    setShow(true);
  };
  const [claimToDelete, setClaimToDelete] = useState(-1);

  const handleMouseOver = (index: number) => {
    setClaims((prev_claims: ClaimGP[]) => {
      let aux = prev_claims.slice();
      if (aux[index].claimer === user) aux[index].hover = true;
      return aux;
    });
  };

  const handleMouseOut = (index: number) => {
    setClaims((prev_claims: ClaimGP[]) => {
      let aux = prev_claims.slice();
      aux[index].hover = false;
      return aux;
    });
  };

  const deleteClaim = () => {
    let token = window.localStorage.getItem("userLogged");
    if (token == null) return;
    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/grandprix/deleteClaim`,
        {
          claimToDelete,
          user,
          token: JSON.parse(token).token,
          grandprix,
        },
      )
      .then(({ data }) => {
        toast.success(`${t("ClaimDeleted")}`);
        setUpdateClaims((prev_value: boolean) => !prev_value);
        handleClose();
      })
      .catch(({ response }) => {
        toast.error(`${t(response.data)}`);
        throw new Error(response);
      });
  };
  return (
    <div id="claims-container" className="news-item">
      <label className="main-title">{t("Claims").toUpperCase()}</label>
      {claims.length === 0 ? (
        <p className="text-center">{t("NoClaimsYet")}</p>
      ) : (
        claims.map((claim, index) => {
          return (
            <div
              className="claim-card"
              key={claim.claim_id ?? index}
              onMouseEnter={() => handleMouseOver(index)}
              onMouseLeave={() => handleMouseOut(index)}
            >
              {/* Número de reclamación */}
              <div className="claim-card-number">
                <span>#C{index + 1}</span>
              </div>

              {/* Contenido */}
              <div className="claim-card-content">
                {/* Cabecera */}
                <div className="claim-card-header">
                  <div className="claim-card-driver">
                    <b>{claim.username}</b>
                  </div>

                  <div className="claim-card-meta">
                    <span>{claim.time}</span>
                    <span className="claim-card-session">
                      {getSessionName(claim.session)}
                    </span>
                  </div>
                </div>

                {/* Descripción */}
                <div className="claim-card-description">
                  {claim.description}
                </div>

                {/* Botones del usuario */}
                {claim.claimer === user && (
                  <div
                    className={`claim-card-actions ${
                      claim.hover ? "show" : ""
                    }`}
                  >
                    <Button text={t("Update")} onClick={() => update(claim)} />

                    <Button
                      text={t("Delete")}
                      onClick={() => handleShow(claim.claim_id)}
                      className="button-red-lvf1"
                    />
                  </div>
                )}
              </div>

              {/* Indicador */}
              <div className="claim-card-arrow">
                <FontAwesomeIcon icon={faAngleRight} />
              </div>
            </div>
          );
        })
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {t("Delete")} {t("Claim")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("DeleteClaimConfirmation")}</Modal.Body>
        <Modal.Footer>
          <Button
            text={t("Close")}
            onClick={handleClose}
            className={"button-neutral-lvf1"}
          />
          <Button
            text={t("Delete")}
            onClick={() => deleteClaim()}
            className={"button-red-lvf1"}
            type="submit"
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ClaimsView;
